export enum COOKIE {
  CIDAAS_DR = 'Cidaas_dr',
}
